export default __webpack_public_path__ + "static/media/spotid.54968df6.svg";